/**
 * Created by CoolGuy on 2017/6/16.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';

const {
    ajaxCommon,
    ajaxCache
} = Ajax;
const TheApi = API('user');
const USER_ADD = "USER_ADD";
const USER_LIST = "USER_LIST";
const USER_EDIT = "USER_EDIT";
const USER_DETAIL = "USER_DETAIL";
const USER_REMOVE = "USER_REMOVE";
const USER_ONE = "USER_ONE";
const USER_ONE_ASYNC = "USER_ONE_ASYNC";
const USER_DEPARTMENT = "USER_DEPARTMENT";
const USER_INFO = "USER_INFO";
const USER_ONE_NOTHING_TO_DO = "USER_ONE_NOTHING_TO_DO";

const SERVICEUSER_TAG_LIST = "SERVICEUSER_TAG_LIST";
const SERVICEUSER_LIST = "SERVICEUSER_LIST";
const SERVICEUSER_DETAIL = "SERVICEUSER_DETAIL";
const SERVICEUSER_EDIT = "SERVICEUSER_EDIT";
const SERVICEUSER_QUESTION_ORDER = "SERVICEUSER_QUESTION_ORDER";
const SERVICEUSER_LOG_LIST = "SERVICEUSER_LOG_LIST";
//import {User} from '../util/TestData';
//const mock = User;

let __userPromise = {};

export default {
    USER_ADD,
    userAdd: (one) => {
        return ajaxCommon({
            api: TheApi('post')(),
            data: one,
            success: (data) => ({
                type: USER_ADD,
                data
            })
        })
    },
    USER_LIST,
    users: (search) => {
        search.page = search.current || 1;//保持antd的风格
        return ajaxCommon({
            //testData:mock.list,
            api: TheApi('get')(),
            data: search,
            success: (data) => ({
                type: USER_LIST,
                data
            })
        })
    },
    USER_EDIT,
    userEdit: (userId, info) => {
        return ajaxCommon({
            api: TheApi('put')(userId),
            data: info,
            success: (data) => ({
                type: USER_EDIT,
                data
            })
        })
    },
    USER_DETAIL,
    userDetail: (userId, isMe) => {
        return ajaxCommon({
            api: TheApi('get')(userId),
            success: (data) => {
                return ({
                    type: USER_DETAIL,
                    isMe,
                    userId,
                    data
                })
            }
        })
    },
    USER_ONE,
    userOne: (userId, isMe) => {
        return ajaxCommon({
            api: TheApi('get')(userId),
            success: (data) => ({
                type: USER_ONE,
                isMe,
                userId,
                data
            })
        })
    },
    USER_ONE_ASYNC,
    userOneAsync: (userId, isMe) => {
        if (__userPromise[userId]) {
            return {
                type: USER_ONE_NOTHING_TO_DO
            };
        } else {
            let promise = ajaxCache({
                cacheKey: `user${userId}`,
                onBeforeCache: (json) => {
                    return JSON.stringify({
                        nickname: json.nickname
                    });
                },
                api: TheApi('get')(userId),
                success: (data) => ({
                    type: USER_ONE,
                    isMe,
                    userId,
                    data
                })
            });

            __userPromise[userId] = promise;

            return promise;
        }
    },
    USER_REMOVE,
    userRemove: (userId) => {
        return ajaxCommon({
            api: TheApi('delete')(userId),
            success: (data) => ({
                type: USER_REMOVE,
                userId,
                data
            })
        })
    },
    USER_DEPARTMENT,
    userDepartment: () => {
        return ajaxCommon({
            api: TheApi('get')('department'),
            success: (data) => ({
                type: USER_DEPARTMENT,
                data
            })
        })
    },
    USER_INFO,
    userInfo: () => {
        return ajaxCommon({
            api: TheApi('get')('logininfo'),
            success: (data) => ({
                type: USER_INFO,
                data
            })
        })
    },
    SERVICEUSER_TAG_LIST,
    serviceUserTagList: () => {
        return ajaxCommon({
            api: {
                url: '/api/v2/serviceuser/taglist',
                method: 'get'
            },
            success: (data) => ({
                type: SERVICEUSER_TAG_LIST,
                data
            })
        })
    },
    SERVICEUSER_LIST,
    serviceUserSearch: (filter, searchAll, directReturn) => {
        let newFilter = {
            ...filter
        };

        if (!searchAll) {
            newFilter = {
                ...filter,
                admins: {
                    ...filter.admins,
                    trash: 0
                }
            };
        }
        return ajaxCommon({
            api: {
                url: '/api/v2/serviceuser/search',
                method: 'POST'
            },
            data: JSON.stringify(newFilter),
            success: (data) => ({
                type: directReturn ? 'SERVICEUSER_LIST_EXPORT' : SERVICEUSER_LIST,
                data
            })
        }, {
            type: 'json_all'
        })
    },
    SERVICEUSER_DETAIL,
    serviceUserDetail: (userId) => {
        return ajaxCommon({
            api: {
                url: '/api/v2/serviceuser/one/' + (userId || 0),
                method: 'get'
            },
            success: (data) => ({
                type: SERVICEUSER_DETAIL,
                data
            })
        })
    },
    SERVICEUSER_LOG_LIST,
    serviceUserLogList: (userId, page, pageSize = 15) => {
        return ajaxCommon({
            api: {
                url: '/api/v2/serviceuser/loglist/' + (userId || 0) + `?page=${page}&page_size=${pageSize}`,
                method: 'get'
            },
            success: (data) => ({
                type: SERVICEUSER_LOG_LIST,
                data
            })
        })
    },
    SERVICEUSER_EDIT,
    serviceUserEdit: (option) => {
        return ajaxCommon({
            api: {
                url: '/api/v2/serviceuser/savecombine',
                method: 'POST'
            },
            data: JSON.stringify(option),
            success: (data) => ({
                type: SERVICEUSER_EDIT,
                data
            })
        }, {
            type: 'json_all'
        })
    },
    SERVICEUSER_QUESTION_ORDER,
    serviceUserQuestionOrder: (userId) => {
        return ajaxCommon({
            api: {
                url: '/api/v2/serviceuser/question/' + userId,
                method: 'get'
            },
            success: (data) => ({
                type: SERVICEUSER_QUESTION_ORDER,
                data
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/actions/UserAction.js